import { FormLabel, OptionType, Radiogroup, RadiogroupOptions, SearchableSelect, Textinput } from "shared";
import {
    ITemplateComponent,
    ITemplateMassGenerationComponent,
    MergeDocTypes
} from "entities/template";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { useComponentValidateFunction } from "../../../../lib/hooks/useComponentValidateFunction";
import { IssueTypeSelect } from "../../form_fields/issue_type_select/issue_type_select";
import styles from "./component_form_massgeneration.module.scss";

interface IComponentFormMassGenerationProps {
    component: ITemplateMassGenerationComponent;
    onChange: (component: ITemplateComponent) => void;
    triggerValidate: number;
}

export const ComponentFormMassGeneration: React.FC<IComponentFormMassGenerationProps> = React.memo(({
                                                                                                        component,
                                                                                                        triggerValidate,
                                                                                                        onChange
                                                                                                    }) => {
    const t = useComponentsTranslations();
    const { requiredFieldValidation } = useComponentValidateFunction();
    const { i18n } = useTranslation();

    const onFieldChange = (value: Partial<ITemplateMassGenerationComponent>) => {
        onChange({
            ...component,
            ...value
        })
    }

    const mergeDocOptions: OptionType[] = useMemo(() => {
        return [
            {
                value: "doc",
                label: "Docx/Pdf"
            },
            {
                value: "txt",
                label: "Xml/Csv"
            },
            {
                value: "zip",
                label: "Zip"
            }]
    }, []);

    const documentFormatOptions: RadiogroupOptions[] = useMemo(() => {
        const options = [{
            label: "Pdf",
            value: "undefined"
        }, {
            label: t("document"),
            value: "rtf"
        }, {
            label: t("withoutDocument"),
            value: "null"
        }]

        return options;
    }, [i18n.language])

    return <div className={styles.container}>
        <FormLabel title={t("trackerQueue")} required={true}>
            <Textinput size="m"
                       value={component.startrekQueue ? component.startrekQueue : ""}
                       triggerValidate={triggerValidate}
                       validate={true}
                       validateFunc={requiredFieldValidation}
                       onChange={(e) => onFieldChange({
                           startrekQueue: e.target.value,
                           issueType: e.target.value !== component.startrekQueue ? undefined : component.issueType
                       })}
                       view="outline"/>
            <div className={styles.subLabel}>{"* " + t("trackerQueueDescription")}</div>
        </FormLabel>
        <IssueTypeSelect
            value={component.issueType}
            startrekQueue={component.startrekQueue}
            onChange={(val) => onFieldChange({
                issueType: val
            })}
        />
        <FormLabel title={t("documentFormat")}>
            <Radiogroup vertical={false}
                        name="mass-generation-form-radio"
                        options={documentFormatOptions}
                        onChange={(val) => {
                            onFieldChange({ format: val === "undefined" ? undefined : val as "rtf" | "null" })
                        }}
                        value={component.format ? component.format : "undefined"}
            />
        </FormLabel>
        <div className={styles.description}>{t("massUploadTicketsDescription")}</div>
        <FormLabel title={t("mergedDocumentFormat")}>
            <SearchableSelect
                options={mergeDocOptions}
                optionValue={component.mergeDoc ? mergeDocOptions.find((o) => o.value === component.mergeDoc) : undefined}
                onChange={(val) => {
                    onFieldChange({ mergeDoc: val ? val as MergeDocTypes : undefined })
                }}
                isMulti={false}
                hideClearIcon={false}
                isSearchable={true}
            />
        </FormLabel>
    </div>;
});
